// @flow
// import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';

export type Location = {
  pathname: string;
  search: string;
};

export type Match = {
  isExact: boolean;
  params: { [key: string]: string };
  path: string;
  url: string;
};

export type HistoryRoute = {
  hash?: string;
  key?: string;
  pathname?: string;
  search?: string;
};


export type History = {
  location: Location;
  listen: (callback: (route: HistoryRoute) => void) => void;
  push: (route: string) => void;
};

export type RouterState = {
  location: Location;
};

const middlewareCreator = (history: History) => routerMiddleware(history);

export { routerReducer, middlewareCreator };
export * from './AlreadyAuthRoute';
export * from './PrivateRoute';
export * from './Status';




// WEBPACK FOOTER //
// ./src/router/index.js